import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout";
// import Users from "../Users";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert2";

export default function EditUser() {
  const { id } = useParams();
  const navigate = useNavigate();
  const ClicktoBack = () => {
    navigate("/users");
  };
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    language: null
  });
  const [languages, setLanguages] = useState([]);

  const fetchUser = async () => {
    try {
      const api = await axios.get(`/api/v1/users/show/${id}`)
      setFormData(api.data.results);
    } catch (err) {
      console.log("Something Wrong");
    }
  };

  useEffect(() => {
    fetchUser();
  }, [id]);

  const handleChange = event => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const onSubmitChange = event => {
    event.preventDefault();

    axios
      .put(`/api/v1/users/update/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      })
      .then(response => {
        swal.fire("Success!", "User has been successfully updated.", "success");
      })
      .catch(error => {
        swal.fire({
          title: "Unable to add user",
          text: error.response.data.message,
          icon: "error",
        });
      });
  };

  const FetchLanguage = () => {
    axios
      .get(`/api/v1/languages`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(response => {
        setLanguages(response.data.results);
      })
      .catch(error => {
        swal.fire({
          title: "Unable to fetch data - Languages",
          text: error.message,
          icon: "error",
        });
      });
  };

  const handleLanguageSelect = (id) => {
    setFormData({ ...formData, language: Number(id) })
  }

  useEffect(() => {
    FetchLanguage();
  }, []);

  return (
    <Layout>
      <div className="page-content">
        <nav className="page-breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              User Edit
            </li>
          </ol>
        </nav>

        <div className="row">
          <div className="col-md-6 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h6 className="card-title">Edit User</h6>

                <form onSubmit={e => onSubmitChange(e)} className="forms-sample">
                  <div className="mb-3">
                    <label htmlFor="exampleInputUsername1" className="form-label">
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name || ""}
                      onChange={handleChange}
                      className="form-control"
                      id="exampleInputUsername1"
                      autoComplete="off"
                      placeholder="Full Name"
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      Email address
                    </label>
                    <input type="email" name="email" value={formData.email || ""} onChange={handleChange} className="form-control" id="exampleInputEmail1" placeholder="Email" />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputPassword1" className="form-label">
                      Password&nbsp;
                      <span style={{ color: '#524e4eff' }}>(Leave blank to keep the current password)</span>
                    </label>
                    <input
                      type="password"
                      name="password"
                      className="form-control"
                      id="exampleInputPassword1"
                      autoComplete="off"
                      placeholder="Password"
                      value={formData.password || ""}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="exampleInputPassword1" className="form-label">
                      Select Language
                    </label>

                    <select
                      className="mb-1 form-control"
                      value={formData.language}
                      onChange={(e) => handleLanguageSelect(e.target.value)}
                    >
                      <option value="" disabled selected>
                        Select Language
                      </option>
                      {languages.map((language) => (
                        <option key={language.id} value={language.id}>
                          {language.language_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <button type="submit" className="btn btn-primary me-2">
                    Submit
                  </button>
                  <button onClick={ClicktoBack} className="btn btn-secondary">
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
